import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import KennelCalendar from '@/components/kennel-calendar.vue';
import { Dogspaces } from '@busy-human/k9-library';
import Modal from '@/components/Modal.vue';
import BulkEdit from '@/components/bulk-edit.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'kennel-count',
  setup(__props, { expose: __expose }) {
  __expose();

const showBulkEdit = ref(false);
const selectedSize = ref(Dogspaces.Sizes.Small);
const timeframe    = ref<{month: number, year: number}>({
	month: new Date().getMonth(),
	year: new Date().getFullYear()
});

// watch(timeframe, async tf => {
// 	await kennelStore.fetchCounts(tf.year, tf.month);
// }, { deep: true, immediate: true });


const __returned__ = { showBulkEdit, selectedSize, timeframe, ref, KennelCalendar, get Dogspaces() { return Dogspaces }, Modal, BulkEdit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})